export default __webpack_public_path__ + "static/media/applause.cdb85aef.mp3";